import { BookingProvider } from "@/context/BookingContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { HairShowcase } from "@/components/HairShowcase";
import { Gallery } from "@/components/Gallery";
import { Branches } from "@/components/Branches";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";
import { BookingModal } from "@/components/BookingModal";

export default function Home() {
  return (
    <BookingProvider>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <HairShowcase />
        <Gallery />
        <Branches />
        <Testimonials />
      </main>
      <Footer />
      <BookingModal />
    </BookingProvider>
  );
}
